import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getRequirementDesignations
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      const options = this.options.map(el => el.name)
      const optionsWithHardCodedValues = options.filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedValues) ].sort()
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.isLoading = true
          const params = {
            school: this.school,
            returnFields: '_id,name',
          }
          const data = await getRequirementDesignations(params) || {}
          this.options = Object.values(data)
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
}
